import CommunityLanding from "./CommunityLanding";

export default function OrganizerLanding({ isGuest = true, language = "en" }) {
  return <CommunityLanding variant="organizer" isGuest={isGuest} language={language} />;
}
